import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  postPAFormFourStart,
  postPAFormFourSuccess,
  postPAFormFourFailure,
} from "../reducers/postPAFormFourReducer";
import axios from "axios";
import Cookies from "js-cookie";
import { getToken } from "./getToken";

export const postPAFormFour = createAsyncThunk(
  "postPAFormFour",
  async ({ values }, thunkAPI) => {
    try {
      thunkAPI.dispatch(postPAFormFourStart());
      const token = Cookies.get("token");

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/PA/SavePAThirdPage`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const responseData = await response;

      thunkAPI.dispatch(postPAFormFourSuccess(responseData?.data));
      console.log(
        responseData?.data?.result,
        "<=========responseData?.data?.result"
      );
      return responseData;
    } catch (error) {
      thunkAPI.dispatch(postPAFormFourFailure(error.response.data.Message));

      if (error.response.data.Message) {
        thunkAPI.dispatch(postPAFormFourFailure(error.response.data.Message));
      } else {
        thunkAPI.dispatch(postPAFormFourFailure(error.response.data.status));
      }
      if (error.response && error.response.status === 401) {
        Cookies.remove("token");

        thunkAPI.rejectWithValue({ unauthorized: true });
        await thunkAPI.dispatch(getToken());
      }
      throw error;
    }
  }
);
